var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get, Post } from "../api/api";
import { USER_ROLE, UpdateProfilePicUrl, UpdateUserProfile, getRolesByIdUrl, getUserProfileUrl, getIdentityPersonalizationListUrl, identityPersonalizationUpdateUrl, identityPersonalizationCreateUrl, organizationStartEndTimeURL, getChannelSettings } from "../api/url";
import { LOCAL_STORAGE_KEYS, ProfileEnum } from "../constants";
import { getLocalStorageItem, setLocalStorageItem } from "../utils/storageHelper";
import { showLoader, showNotification } from "./commonSlice";
import { createAPI, getByIdAPI, getListAPI, updateAPI } from "./crudSlice";
import { t } from "i18next";
import { GoogleAnlyticsErrorLog } from "../utils/utils";
var initialState = {
    getUserRoles: getLocalStorageItem(USER_ROLE),
    status: "idle",
    ProfilePicUrl: ''
};
export var getUserRoles = createAsyncThunk("getuserroles", function (request, _ref) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, profileData, response, _response$data, _response$data2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref.dispatch;
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                return [4 /*yield*/, Post(getRolesByIdUrl)];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 && response !== null && response !== void 0 && response.success && response.data.length > 0) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    GoogleAnlyticsErrorLog(profileData, getRolesByIdUrl, response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.errorCode);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errorCode,
                        // "Please check branch mapping of employee and user.",
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var getProfilePersonalDetails = createAsyncThunk("getprofilepersonaldetails", function (request, _ref2) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, response, profileData, _response$data3, _response$data4, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref2.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Get(getUserProfileUrl)];
            case 2:
                response = _a.sent();
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 && response !== null && response !== void 0 && response.success) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    GoogleAnlyticsErrorLog(profileData, getUserProfileUrl, response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.errorCode);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.errorCode,
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var uploadProfileImage = createAsyncThunk("uploadprofileimage", function (request, _ref3) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, profileData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref3.dispatch;
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                return [4 /*yield*/, Post(UpdateProfilePicUrl, request)];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || response !== null && response !== void 0 && response.success) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Profile uploaded sccuessfully",
                        type: "success"
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    GoogleAnlyticsErrorLog(profileData, UpdateProfilePicUrl, t("Update profile pic failed"), request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Update profile pic failed"),
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var updateProfileDetails = createAsyncThunk("updateprofiledetails", function (request, _ref4) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, profileData, response, _response$data5, _response$data6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref4.dispatch;
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                return [4 /*yield*/, Post(UpdateUserProfile, request)];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.statusCode) === 200 || response !== null && response !== void 0 && response.success) {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, response];
                }
                else {
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    GoogleAnlyticsErrorLog(profileData, UpdateUserProfile, response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.errorCode, request);
                    dispatch(showNotification({
                        isOpen: true,
                        message: response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.errorCode,
                        type: "error"
                    }));
                    return [2 /*return*/, response];
                }
                return [2 /*return*/];
        }
    });
}); });
export var saveChannelIdDetails = createAsyncThunk("", function (payload, _ref5) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, request, storedIdentityPersonalizationList, identityPersonalizationId, response, _response, _response2, _response3, _response4, _response5, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref5.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 12, , 14]);
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 2:
                _a.sent();
                request = {
                    Name: ProfileEnum.Profile,
                    Key: ProfileEnum.Profile,
                    SystemName: ProfileEnum.Identity,
                    Value: {
                        ChannelDetails: payload === null || payload === void 0 ? void 0 : payload.selectedBranchChannel,
                        BranchDetails: payload === null || payload === void 0 ? void 0 : payload.selectedBranchData
                    },
                    SetDefault: true
                };
                storedIdentityPersonalizationList = getLocalStorageItem(LOCAL_STORAGE_KEYS.IDENTITY_PERSONALIZATION_LIST);
                identityPersonalizationId = storedIdentityPersonalizationList === null || storedIdentityPersonalizationList === void 0 ? void 0 : storedIdentityPersonalizationList.IdentityPersonalizationId;
                response = void 0;
                if (!identityPersonalizationId) return [3 /*break*/, 7];
                return [4 /*yield*/, dispatch(updateAPI({
                        key: '',
                        url: identityPersonalizationUpdateUrl(identityPersonalizationId),
                        request: request
                    }))];
            case 3:
                response = _a.sent();
                if (!(((_response = response) === null || _response === void 0 || (_response = _response.payload) === null || _response === void 0 ? void 0 : _response.statusCode) === 200 && (_response2 = response) !== null && _response2 !== void 0 && (_response2 = _response2.payload) !== null && _response2 !== void 0 && _response2.success)) return [3 /*break*/, 6];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, dispatch(getSavedIdentityList(null))];
            case 5:
                _a.sent();
                return [2 /*return*/, response];
            case 6: return [3 /*break*/, 11];
            case 7: return [4 /*yield*/, dispatch(createAPI({
                    key: '',
                    url: identityPersonalizationCreateUrl,
                    request: request
                }))];
            case 8:
                response = _a.sent();
                if (!((((_response3 = response) === null || _response3 === void 0 || (_response3 = _response3.payload) === null || _response3 === void 0 ? void 0 : _response3.statusCode) === 201 || ((_response4 = response) === null || _response4 === void 0 || (_response4 = _response4.payload) === null || _response4 === void 0 ? void 0 : _response4.statusCode) === 200) && (_response5 = response) !== null && _response5 !== void 0 && (_response5 = _response5.payload) !== null && _response5 !== void 0 && _response5.success)) return [3 /*break*/, 11];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 9:
                _a.sent();
                return [4 /*yield*/, dispatch(getSavedIdentityList(null))];
            case 10:
                _a.sent();
                return [2 /*return*/, response];
            case 11: return [3 /*break*/, 14];
            case 12:
                e_1 = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 13:
                _a.sent();
                console.log("Error-", e_1);
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}); });
export var getSavedIdentityList = createAsyncThunk("savedIdentityList", function (request, _ref6) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, _result$payload, _result$payload2, result, _result$payload3, _result$payload4, _data$BranchDetails, _channelSettingsResul, _result$payload5, data, body, organizationTimeResult, _organizationTimeResu, _organizationTimeResu2, StartDateTime, EndDateTime, channelSettingsResult, findMobileNoRegexAttribute, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch = _ref6.dispatch;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 10]);
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: '',
                        url: getIdentityPersonalizationListUrl
                    }))];
            case 3:
                result = _a.sent();
                if (!((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) === 200 && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success)) return [3 /*break*/, 7];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 4:
                _a.sent();
                data = result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data[0].Value;
                setLocalStorageItem(LOCAL_STORAGE_KEYS.IDENTITY_PERSONALIZATION_LIST, result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.data[0]);
                setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL, data === null || data === void 0 ? void 0 : data.ChannelDetails);
                setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH, data === null || data === void 0 ? void 0 : data.BranchDetails);
                body = {
                    OrganizationId: data === null || data === void 0 || (_data$BranchDetails = data.BranchDetails) === null || _data$BranchDetails === void 0 ? void 0 : _data$BranchDetails.OrganizationId
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: organizationStartEndTimeURL,
                        request: body
                    }))];
            case 5:
                organizationTimeResult = _a.sent();
                if (organizationTimeResult.payload.value.success && organizationTimeResult.payload.value.data) {
                    StartDateTime = (_organizationTimeResu = organizationTimeResult.payload.value.data.find(function (item) { return item.AttributeName === "StartDateTime"; })) === null || _organizationTimeResu === void 0 ? void 0 : _organizationTimeResu.Value;
                    EndDateTime = (_organizationTimeResu2 = organizationTimeResult.payload.value.data.find(function (item) { return item.AttributeName === "EndDateTime"; })) === null || _organizationTimeResu2 === void 0 ? void 0 : _organizationTimeResu2.Value;
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_TIMING, {
                        StartDateTime: StartDateTime,
                        EndDateTime: EndDateTime
                    });
                }
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: getChannelSettings
                    }))];
            case 6:
                channelSettingsResult = _a.sent();
                if ((_channelSettingsResul = channelSettingsResult.payload) !== null && _channelSettingsResul !== void 0 && _channelSettingsResul.success && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && _result$payload5.data) {
                    findMobileNoRegexAttribute = result.payload.data.find(function (item) { return item.Key === "MOBILE_NO_REGEX"; });
                    if (findMobileNoRegexAttribute) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX, findMobileNoRegexAttribute.Value);
                    }
                }
                _a.label = 7;
            case 7: return [3 /*break*/, 10];
            case 8:
                e_2 = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 9:
                _a.sent();
                console.log("Error-", e_2);
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); });
export var profileSlice = createSlice({
    name: "organization",
    initialState: initialState,
    reducers: {
        setProfilePic: function (state, action) {
            return _objectSpread(_objectSpread({}, state), {}, {
                ProfilePicUrl: action.payload
            });
        }
    },
    extraReducers: function (builder) {
        builder.addCase(getUserRoles.pending, function (state) {
            state.status = "loading";
        }).addCase(getUserRoles.fulfilled, function (state, action) {
            state.status = "idle";
            state.getUserRoles = action.payload;
        }).addCase(getUserRoles.rejected, function (state) {
            state.status = "failed";
            state.getUserRoles = null;
        });
    }
});
export var setProfilePic = profileSlice.actions.setProfilePic;
var profileReducer = profileSlice.reducer;
export default profileReducer;
